import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useAccount } from "../../../hooks/client";
import { ManageArrears } from "../../../components/icons";
import { CircleButtonWithContent } from "./circleButtonWithContent";
import { ManageMyRepaymentModal } from "./manageMyRepaymentModal";
import { MANAGE_ARREARS_ROUTE } from "../containers/IncreaseRepayments/route.constants";
import { Wrapper } from "./manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { TextButtonModal } from "./manageMyRepaymentModal/textButtonModal";
import {
  MANAGE_MY_ARREARS_STATES
} from "../../../constants/commonConstants";
import environmentSettings from "@constants/environmentSettings";
import { useMagicBlocksAvailable } from "@utils/helpers/useMagicBlocksAvailable";

const ModalMessage = () => {
  const { phone, email } = environmentSettings;
  const showChatToUsOnlineButton = useMagicBlocksAvailable();

  const startChat = () => {
    document.getElementsByTagName('magicblocks-widget')[0].setAttribute('open', true)
  };

  return (
    <Wrapper>
      Please call&nbsp;<a href={`tel:${phone}`}>{phone}</a>&nbsp;or
      email&nbsp;
      <a href={`mailto:${email}`}>
        {email}
      </a>
      &nbsp;to discuss.
        {showChatToUsOnlineButton && (
          <>
          Alternatively you can&nbsp;
          <TextButtonModal onClick={startChat}>
            chat to us online
          </TextButtonModal>
          .
        </>
      )}
    </Wrapper>
  );
};

export const ManageMyArrears = ({ accountId }) => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const { url } = useRouteMatch();

  const { arrears } = useAccount(accountId) || {};

  const manageMyArrearsUrl =
    url + MANAGE_ARREARS_ROUTE.ARREARS + "?accountId=" + accountId;

  const clickManageArrears = () => {
    switch (arrears) {
      case MANAGE_MY_ARREARS_STATES.ARREARS_LESS_THAN_THREE:
      case MANAGE_MY_ARREARS_STATES.ARREARS_EXPIRED_MATURITY_DATE:
      case MANAGE_MY_ARREARS_STATES.ARREARS: {
        history.push(manageMyArrearsUrl);
        break;
      }
      case MANAGE_MY_ARREARS_STATES.SHOW_CONTACT_US:
      case MANAGE_MY_ARREARS_STATES.REDIRECT_MANAGE_REPAYMENTS:
      default: {
        setShowModal(true);
        break;
      }
    }
  };

  return (
    <>
      <CircleButtonWithContent variant="bad" onClick={clickManageArrears}>
        <ManageArrears width="50px" />
        <span>Manage</span>
        <span>My Arrears</span>
      </CircleButtonWithContent>
      <ManageMyRepaymentModal
        visible={showModal}
        close={() => setShowModal(false)}
        header="Manage My Arrears"
      >
        <ModalMessage />
      </ManageMyRepaymentModal>
    </>
  );
};
